<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh/yingxiang">盛京映像</router-link>
    </div>

    <div class="mt50 tv">
      <div class="container-width">
        <div class="tv-title">《盛京映像》</div>
        <div class="tv-content">
          <div class="t-left">
            <!--   width: 490px; /* 490*1.65 */   height: 453px; /* 275*1.65 */ -->



            <hls-video
              :videoUrl="current.video"
              class="videoBox"
              :videoType="current.videoType"
              style="height: 370px; width: 100%"
              v-if="renderComponent && videoType == 'mp4'"
              :poster="current.img"
            ></hls-video>
            <hls-video
              :videoUrl="current.video"
              class="videoBox"
              :videoType="videoType"
              style="height: 370px; width: 100%"
              v-if="renderComponent && videoType == 'flv'"
              :poster="current.img"
            ></hls-video>

            <div class="title">当前播放的是：{{ current.title }}</div>
            <div class="download">
              <a :href="current.url" target="_blank">【点击下载】</a>
            </div>
          </div>
          <div class="t-right">
            <ul class="v-list">
              <li
                @click="changeTv(item)"
                v-for="(item, index) in list"
                :key="index"
                :class="current.id == item.id ? 'active' : ''"
              >
                <div class="">
                  <span class="t-name">{{ item.title }}</span>
                  <span class="t-time">【{{ item.releaseDate }}】</span>
                </div>
                <i
                  class="iconfont icon-bofang"
                  v-if="current.id == item.id"
                ></i>
              </li>
            </ul>
            <div class="pagination">
              <el-pagination
                :pager-count="5"
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/sjwh";
import config from "../../config/dev";
import BANNER from "../../components/banner/sjwh";
import HlsVideo from "@/components/HlsVideo";
export default {
  name: "YINGXIANG",
  data() {
    return {
      navigationData: [
        {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        {
          name: "盛京医讯",
          path: "/sjwh/zhoukan",
          width: "33%",
        },
        {
          name: "盛京TV",
          path: "/sjwh/tv",
        },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh/yingxiang",
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 1,
      list: [],
      total: 0,
      config: config,
      flvPlayer: null,
      current: {
        title: "",
        video: "", // 视频地址
        url: "", // 下载地址
      },

      id: 1,
      renderComponent: false,
      videoType: "flv",
    };
  },
  components: { BANNER, HlsVideo },
  computed: {},
  created() {},
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getSjImageList(parmes, (res) => {
        console.log("res", res);
        this.total = res.totalElements || 0;
        this.totalPages = parseInt(res.totalPages) || 0;
        if (res.content.length) {
          // config.url + "/file/getVideo?id=" + item.video
          // config.url + "/file/downloadFile/" + item.video + "?isDownload=true";
          res.content.map((item, index) => {
            // 处理下载地址 和 视频地址
            if (item.url) {
              item.video = item.url;
            } else {
              // 下载地址
              item.url =
                config.url +
                "/file/downloadFile/" +
                item.video +
                "?isDownload=true";
              // 视频地址
              item.video = config.url + "/file/getVideo?id=" + item.video;
            }
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });
        }
        this.current = { ...res.content[0] };
        this.list = res.content || [];
        this.videoType = res.content[0].videotype;
        this.renderComponent = true;
      });
    },
    changeTv(item) {
      // 从 DOM 中删除 my-component 组件
      this.renderComponent = false;
      this.$nextTick(() => {
        // 在 DOM 中添加 my-component 组件
        this.renderComponent = true;
        this.videoType = item.videotype;
        this.current = { ...item };
      });
    },

    handleCurrentChange(indexPage) {
      this.pageIndex = indexPage;
      this.init();
    },
  },
  mounted() {
    this.init();
    // eruda.init();

  },
  watch: {},
};
</script>


<style scoped lang="scss">
.tv {
  background: #e6effc;
  .container-width {
    padding: 50px 0px;
    box-sizing: border-box;
    margin-bottom: 50px;
    .tv-title {
      display: block;
      width: 100%;
      text-align: center;
      font-size: 32px;
      margin-bottom: 30px;
    }
    .tv-content {
      display: -webkit-flex;
      display: flex;
      .t-left {
        background: #fff;
        padding: 30px 20px;
        box-sizing: border-box;
        border-radius: 5px;
        text-align: center;
        flex: 2.5;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          margin: 20px auto 0;
          text-align: center;
          font-size: 24px;
        }
        .download {
          text-align: center;
          margin-top: 10px;
          a {
            font-size: 16px;
          }
        }
      }
      .t-right {
        background: #fff;
        padding: 30px 20px;
        box-sizing: border-box;
        margin-left: 30px;
        border-radius: 5px;
        position: relative;
        flex: 1;
        .v-list {
          display: -webkit-flex;
          display: flex;
          flex-wrap: wrap;
          li {
            width: 100%;
            padding: 10px 10px;
            margin: 0 0px 10px;
            box-shadow: 0 4px 7px rgba (0, 0, 0, 0.14);
            overflow: hidden;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            transition: 0.5s;
            background-color: #e7effc;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: justify;
            -webkit-justify-content: space-between;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            align-items: center;
            cursor: pointer;
            .t-name {
              font-size: 16px;
              height: 20px;
              display: block;
            }
            .t-time {
              font-size: 12px;
              color: #999;
              display: block;
              margin-top: 10px;
            }
            i {
              font-size: 30px;
            }
          }
          li:hover {
            background: #00479d;
            color: #fff;
            .t-time {
              color: #fff;
            }
          }
          .active {
            background: #00479d;
            color: #fff;
            .t-time {
              color: #fff;
            }
          }
        }
        .pagination {
          width: 410px;
          margin-top: 20px;
          margin-bottom: 0px;
          display: -webkit-flex;
          display: flex;
          -webkit-justify-content: center;
          justify-content: center;

          position: absolute;
          bottom: 20px;
          text-align: center;
        }
      }
    }
  }
  /deep/ .el-pager {
    li {
      padding: 0 20px !important;
    }
  }
}
@media only screen and (max-width: 728px) {
  .tv {
    .container-width {
      padding: 30px 0px;
      margin-bottom: 30px;

      .tv-content {
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: vertical; /* android 2.1-3.0, ios 3.2-4.3 */
        -webkit-flex-direction: column; /* Chrome 21+ */
        -ms-flex-direction: column; /* WP IE 10 */
        flex-direction: column; /* android 4.4 */
        .t-left {
          background: #fff;
          padding: 15px 10px;
          box-sizing: border-box;
          border-radius: 5px;
          .title {
            margin: 20px auto 0;
            text-align: center;
            font-size: 1.2rem;
          }
          video {
            width: 100%;
            height: auto;
          }
          .download {
            text-align: center;
            margin-top: 10px;
            a {
              font-size: 16px;
            }
          }
        }
        .t-right {
          padding: 15px 10px;
          margin-left: 0px;
          width: 100%;
          min-height: 200px;
          margin-top: 15px;
          .v-list {
            display: -webkit-flex;
            display: flex;
            flex-wrap: wrap;
            li {
              width: 100%;
              padding: 10px 10px;
              margin: 0 0px 10px;
              box-shadow: 0 4px 7px rgba (0, 0, 0, 0.14);
              overflow: hidden;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              transition: 0.5s;
              background-color: #e7effc;
              display: -webkit-flex;
              display: flex;
              -webkit-box-pack: justify;
              -webkit-justify-content: space-between;
              -ms-flex-pack: justify;
              justify-content: space-between;
              -webkit-box-align: center;
              align-items: center;
              cursor: pointer;
              .t-name {
                font-size: 16px;
                height: 20px;
                display: block;
              }
              .t-time {
                font-size: 12px;
                color: #999;
                display: block;
                margin-top: 10px;
              }
              i {
                font-size: 30px;
              }
            }
            li:hover {
              background: #00479d;
              color: #fff;
              .t-time {
                color: #fff;
              }
            }
            .active {
              background: #00479d;
              color: #fff;
              .t-time {
                color: #fff;
              }
            }
          }
          .pagination {
            width: 100%;
            position: initial;
          }
        }
      }
    }
  }
}
</style>
